import React from 'react';

const EurekaMoments = ({toSection,section}) => {
  const ExperimentIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 8V20L8 32H32L25 20V8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15 8H25" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M12 28H28" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M20 8V4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M17 16L23 16" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="20" cy="24" r="2" fill="white"/>
    </svg>
  );
  
  const ThinkingIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="18" r="10" stroke="white" strokeWidth="2"/>
      <path d="M20 32V28" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M14 32H26" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M17 18H23" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M20 15V21" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M15 11L25 25" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
  
  const GroupIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="12" r="4" stroke="white" strokeWidth="2"/>
      <circle cx="10" cy="24" r="3" stroke="white" strokeWidth="2"/>
      <circle cx="30" cy="24" r="3" stroke="white" strokeWidth="2"/>
      <path d="M20 16V32" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M10 27V32" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M30 27V32" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M16 32H24" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
  
  const MaterialsIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 8H32V32H8V8Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 14H26V26H14V14Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 20H26" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M20 14V26" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
  
  const TopicsIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 8L20 4L28 8L20 12L12 8Z" stroke="white" strokeWidth="2" strokeLinejoin="round"/>
      <path d="M12 8V28L20 32L28 28V8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20 12V32" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M15 18L25 18" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M15 24L25 24" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
  
  const AgeRangeIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="16" stroke="white" strokeWidth="2"/>
      <path d="M15 16C15 13.7909 16.7909 12 19 12H21C23.2091 12 25 13.7909 25 16V24C25 26.2091 23.2091 28 21 28H19C16.7909 28 15 26.2091 15 24V16Z" stroke="white" strokeWidth="2"/>
      <path d="M15 20H25" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );

  const features = [
    {
      title: "Hands on learning through experiments",
      Icon: ExperimentIcon,
      color: "#FF6B2C"
    },
    {
      title: "Inspiring critical thinking and problem solving",
      Icon: ThinkingIcon,
      color: "#FF1278"
    },
    {
      title: "Working in small groups of 10 with a personalized approach to each child",
      Icon: GroupIcon,
      color: "#1678F2"
    },
    {
      title: "Exclusive access to specially designed and branded didactic materials and books",
      Icon: MaterialsIcon,
      color: "#FF6B2C"
    },
    {
      title: "Wide range of topics covering 7 continuous years of learning",
      Icon: TopicsIcon,
      color: "#FF1278"
    },
    {
      title: "For all pre-school and elementary school children ages 3-14",
      Icon: AgeRangeIcon,
      color: "#1678F2"
    }
  ];

  return (
    <div style={{marginTop: '-40px'}} id={section}  className="relative">
      {/* Top wave (keep the same) */}
      <div style={{zIndex: 1}} className="absolute top-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px', transform: 'rotate(180deg)' }}
        >
          <path 
            fill="#B8E1FF"
            fillOpacity="1" 
            d="M0,160L48,144C96,128,192,96,288,80C384,64,480,64,576,80C672,96,768,128,864,128C960,128,1056,96,1152,80C1248,64,1344,64,1392,64L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>

      <div className="bg-white relative py-20">
        <div className="container mx-auto px-4">
          <div className="my-10 mx-auto">
            <h2 className="font-['Grandstander'] text-4xl font-extrabold text-center text-[#002147] mb-8">
              TINKER LABS – Inspiring Eureka Moments
            </h2>

            <p className="text-[#002147] text-lg text-center mb-16 font-['Lexend']">
              One of the principles of the Tinker Labs children's educational franchise is to create an environment where children experience "Aha" moments, sparking their imagination and exploration of the world through creative and interactive STEAM activities, inspiring future innovators and thinkers.
            </p>

            {/* Updated Feature Icons Grid with Colored Circles */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
              {features.map((feature, index) => (
                <div 
                  key={index} 
                  className="flex items-center bg-[#002147] rounded-xl p-6 hover:shadow-lg transition-shadow"
                >
                  <div className="flex-shrink-0 mr-4">
                    <div 
                      className="w-16 h-16 rounded-full flex items-center justify-center"
                      style={{ backgroundColor: feature.color }}
                    >
                      <feature.Icon />
                    </div>
                  </div>
                  <p className="font-['Lexend'] text-white text-left flex-1">{feature.title}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom wave (keep the same) */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px' }}
        >
          <path 
            fill="#002147"
            d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default EurekaMoments;